import { defineComponent as _defineComponent } from 'vue'
import {cityData} from '@/assets/cityData';
import defaultFormat from 'moment';
import {ref} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CityTreeSelector',
  props: {
    modelValue: {
        type: String,
        default: '',
    },
    id: {
        type: String,
        default: '',
    },
},
  emits: ['update:modelValue', 'update:id', 'confirm'],
  setup(__props, { expose, emit }) {
  expose();

const props = __props





const cityList = ref(JSON.parse(JSON.stringify(cityData).replace(/label/g, 'text').replace(/value/g, 'id')));
const cityTreeIndex = ref(0);
const cityTreeCityIndex = ref(0);

const clickNav = (index: number) => {
    cityTreeCityIndex.value = 0;
    emit('update:modelValue', cityList.value[index].id);
    // cityTreeIndex.value = index;
};

const setArea = (id: string) => {
    emit('update:id', id);
    emit('confirm', id);
};

const __returned__ = { props, emit, cityList, cityTreeIndex, cityTreeCityIndex, clickNav, setArea, cityData, defaultFormat, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})